let Vue = require('vue');

let {debounce} = require('sci/utils');

let filter = (maskName, value, defaultValue) => {
    if (value === "" || value === undefined || value === null) {
        if (!defaultValue) {
            switch (maskName) {
                case "simplePercentage":
                case "money":
                case "meters":
                case "squareMeters":
                    return 0;
                default:
                    return null;
            }
        }
        return defaultValue;
    }

    switch (maskName) {
        case "simplePercentage":
        case "money":
        case "meters":
        case "squareMeters":
            return parseFloat(value
                    .replace(/\./g, '')
                    .replace(/,/g, '.')
                ) || filter(maskName, null, defaultValue);
        default:
            return value;
    }
};

Vue.directive('mask', {
    twoWay: true,
    priority: 1000,

    params: ['mask', 'digits', 'default', 'allow-masked'],

    bind: function () {
        let self = this;

        let maskParams = {
            clearMaskOnLostFocus: true
        };

        if (this.params.digits !== null) {
            maskParams.digits = this.params.digits;
        }

        $(this.el).inputmask({
            alias: self.params.mask,
            ...maskParams
        }).on('change keyup', function (evt, ignore = false) {
            if (ignore) {
                return;
            }

            let it = $(this);

            let value = filter(self.params.mask, it.inputmask('unmaskedvalue'), self.defaultValue);

            self.set(value);
        }).on('blur', function () {
            let it = $(this);

            let value = filter(self.params.mask, it.inputmask('unmaskedvalue'), self.defaultValue);


            self.set(value);
            it.val(value).trigger('change', true)
        });
    },
    update: function (value) {
        $(this.el).val(value).trigger('change', true)
    },
    unbind: function () {
        //$(this.el).off().select2('destroy')
    },
    methods: {},
    computed: {
        defaultValue() {
            return this.params.default || null;
        }
    }
});




// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/mask.js